<template>
  <div>
    <form-validator v-model="formValidatorValid">
      <fieldset :disabled="disabled">
        <!-- <div class="row">
          <div class="col-md-12">
            <address-auto-complete @input="getPlaceDetails"></address-auto-complete>
          </div>
        </div> -->
        <!-- <hr /> -->
        <div class="row">
          <div class="col-sm-6">
            <xm-input name="line1" label="Street Address" v-model="formValues.line1" required error="Please enter a valid address" pattern="[a-zA-Z0-9]+" error-style="address-name-style text-danger"></xm-input>
          </div>
          <div class="col-sm-6">
            <xm-input name="line2" label="Address Line 2" v-model="formValues.line2"></xm-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <xm-input name="city" label="City" v-model="formValues.city" required pattern="[a-zA-Z0-9]+" error="Please enter a valid city" error-style="address-name-style text-danger"></xm-input>
          </div>
          <div class="col-sm-4">
            <label for="us-states" class="col-form-label">State</label>
            <us-states id="us-states" v-model="formValues.state"></us-states>
            <small v-if="!stateValid" class="text-danger">Please enter a valid state</small>
          </div>
          <div class="col-sm-4">
            <xm-input name="zip_code" label="Zip Code" v-model="formValues.zip_code" required error="Please enter a valid zip code" pattern="^\d{5}(?:[-\s]\d{4})?$" error-style="address-name-style text-danger"></xm-input>
          </div>
          <!-- <div class="col-sm-3">
            <xm-input name="zip_ext" label="Zip Code Ext" v-model="formValues.zip_ext"></xm-input>
          </div> -->
        </div>
      </fieldset>
    </form-validator>
  </div>
</template>

<script>
import FormValidator from '../FormValidator.vue';
import AddressAutoComplete from './AddressAutoComplete.vue';
import usStates from './UsStates.vue';
import XmInput from '../XmInput.vue';

export default {
  name: "AddressForm",
  components:{
    FormValidator,
    XmInput,
    AddressAutoComplete,
    usStates
  },
  props:{
    value: {
      required: false,
    },
    initValues:{
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted(){
    let iv = this.initValues || {}
    let v = this.value || {}
    iv = iv.hasOwnProperty('address') ? iv.address : iv
    this.formValues.line1 = iv.line1 || v.line1 || ''
    this.formValues.line2 = iv.line2 || v.line2 || ''
    this.formValues.city = iv.city || v.city ||''
    this.formValues.state = iv.state || v.state || ''
    this.formValues.zip_code = iv.zip_code || v.zip_code || ''
    this.formValues.zip_ext = iv.zip_ext || v.zip_ext || ''
  },
  data(){
    return {
      formValidatorValid: false,
      placeid: '',
      formValues: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip_code: '',
        zip_ext: ''
      },
    }
  },
  watch:{
    formValid(newv){
      this.$emit('form-state', newv);
    },

    formValues:{
      handler: function (newv){
        this.$emit('input', newv)
        let addr = {line1: newv.line1, line2: newv.line2, city: newv.city, state: newv.state, zip_code:newv.zip_code}
        if (newv.zip_ext){
          addr.zip_code = this.formValues.zip_code + '-' + this.formValues.zip_ext
        }
        this.validateAddress(addr)
      },
      deep: true
    },
    initValues:{
      handler: function (newv){
        let iv = newv || {}
        iv = iv.hasOwnProperty('address') ? iv.address : iv
        this.formValues.line1 = iv.line1 || ''
        this.formValues.line2 = iv.line2 || ''
        this.formValues.city = iv.city || ''
        this.formValues.state = iv.state || ''
        this.formValues.zip_code = iv.zip_code || ''
        this.formValues.zip_ext = iv.zip_ext || ''
      },
      deep: true
    }
  },

  computed : {
    stateValid() {
      return this.formValues.state.trim().length >= 2;
    },
    formValid () {
      return this.formValidatorValid && this.stateValid;
    }
  },

  methods:{
    getPlaceDetails(placeid){
      let addr_id = placeid.addr_id
      let self = this
      $.ajax({
        type: 'post',
        url: '/manage/api/v1.0/self_signup/address/details',
        contentType: 'application/json',
        data: JSON.stringify({addr_id}),
        success(result){
          let addr = result.address
          let zip_split = addr.zip_code.split('-')
          self.formValues.line1 = addr.line1
          if (addr.line2){
            self.formValues.line2 = addr.line2
          }
          self.formValues.city = addr.city
          self.formValues.state = addr.state
          self.formValues.zip_code = zip_split[0]
          self.formValues.zip_ext = zip_split[1] || ''

        }
      })
    },
    validateAddress(addr){
      let self = this
      $.ajax({
        type: 'post',
        url: '/manage/api/v1.0/self_signup/address/validate',
        contentType: 'application/json',
        data: JSON.stringify(addr),
        success(result){
          // console.log('validateAddress result', result)
        }
      })
    }
  }
}
</script>

<style>
  .address-name-style {
    font-size: smaller !important;
  }
</style>



// WEBPACK FOOTER //
// AddressForm.vue?e232339e